import { render } from "./VendorManagement.vue?vue&type=template&id=d6470cee&scoped=true"
import script from "./VendorManagement.vue?vue&type=script&lang=js"
export * from "./VendorManagement.vue?vue&type=script&lang=js"

import "./VendorManagement.vue?vue&type=style&index=0&id=d6470cee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6470cee"]])

export default __exports__